import { Badge } from "../ui/badge";
import { timeAgo } from "../../lib/storage";
import { useLanguage } from "../../i18n/LanguageContext";

function statusToneClass(status) {
  if (status === "approved" || status === "completed") {
    return "border-[#2B7A6B]/40 text-[#2B7A6B] bg-[#E3F0EC]";
  }
  if (status === "rejected") return "border-red-300 text-red-600 bg-red-50";
  return "border-[#E6E0D4] text-[#0B1F3A]/70 bg-[#F3EFE7]";
}

// Compact list of the current user's most recent requests.
export default function RecentRequestsList({ recent, suppliers }) {
  const { t } = useLanguage();
  if (recent.length === 0) return <p className="py-10 text-center text-sm text-[#0B1F3A]/55">You have not placed any orders yet.</p>;
  return (
    <section className="mt-4">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="font-serif-display text-2xl">Your orders</h2>
        <span className="text-xs text-[#0B1F3A]/55">
          {recent.length} {recent.length > 1 ? t("requests") : t("request")}
        </span>
      </div>
      <div className="bg-white border border-[#E6E0D4] rounded-xl divide-y divide-[#EEE8DC]">
        {recent.map((r) => {
          const sup = suppliers.find((s) => s.id === r.vendor);
          const itemCount = r.items?.length || 0;
          return (
            <div key={r.id} className="px-4 py-4">
              <div className="flex items-center gap-3">
              <div className="h-8 w-8 rounded-full bg-[#EDEAE2] flex items-center justify-center text-xs font-medium">
                {itemCount}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate">{sup?.name || "—"}</p>
                <p className="text-xs text-[#0B1F3A]/55 truncate">{timeAgo(r.createdAt)}</p>
              </div>
              <Badge variant="outline" className={statusToneClass(r.status)}>{r.status}</Badge>
              </div>
              <div className="mt-3 ml-11 space-y-1.5">
                {(r.items || []).map((item) => (
                  <div key={item.itemId || item.productId} className="flex justify-between gap-4 text-sm">
                    <span className="text-[#0B1F3A]">{item.productName || "Item"}</span>
                    <span className="text-[#0B1F3A]/60 shrink-0">{item.quantity || 0} {item.unit || ""}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
